<ul>
    <li *ngFor="let element of breadcrumbs; let last = last">
        <a *ngIf="!element['empty'] && !last; else emptyUrl"
           [routerLink]="element['url']">
            {{element['label']}}
        </a>
        <ng-template #emptyUrl>{{element['label']}}</ng-template>
    </li>
</ul>
